import { create } from 'zustand';

// Whether a login just completed in this tab. The prompt is a post-login
// moment, so it is driven by this rather than by auth state — keying off
// "logged in" would re-ask on every page load.
interface PasskeyPromptState {
    loginJustCompleted: boolean;
    actions: {
        loginCompleted: (usedPasskey: boolean) => void;
        consume: () => void;
    };
}

export const usePasskeyPromptStore = create<PasskeyPromptState>()((set) => ({
    loginJustCompleted: false,

    actions: {
        // Someone who just signed in with a passkey does not need to be offered
        // the thing they used.
        loginCompleted: (usedPasskey: boolean) => set({ loginJustCompleted: !usedPasskey }),
        consume: () => set({ loginJustCompleted: false }),
    },
}));
